/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        url: "https://demo-api-parametro.klefki.io/core/v1/graphql/",
      },
    ],
    rest: {
      loginServer: {
        baseURL: "https://demo-api-parametro.klefki.io/iam/v1",
      },
    },
  },
  defaultLoading: {
    image:
      "https://s3.ap-south-1.amazonaws.com/io.vlinder.public/vlinder-logo-with-title.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Student",
      holders: "Students",
      issuer: "Organization",
    },
    Holders: {
      title: "Students",
    },
    HoldersGroups: {
      title: "Students Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
};
